var Strings = {
    en: {
        title: 'Manage Communication Preferences | Esendex',
        headingMain: 'Update my preferences',
        headingDetails: 'My contact details',
        headingPreferences: 'I want to receive marketing communications via',
        labelCopyright: '&copy; Commify UK Ltd 2019',
        labelEmail: 'Email address:',
        labelTypeNewproducts: 'New Products / Features',
        labelTypeNews: 'News and Research',
        labelTypeSupport: 'Support Messages',
        labelTypeEvents: 'Events Information',
        labelTypeSurveys: 'Surveys / Feedback Requests',
        labelTypePromotions: 'Promotions / Offers',
        labelChannelEmail: 'Email',
        labelChannelSMS: 'SMS',
        labelLoading: 'Loading...',
        buttonProceed: 'Proceed',
        buttonLoading: '<span>.</span><span>.</span><span>.</span>',
        buttonSave: 'Save preferences',
        buttonSubscribe: 'Subscribe to all',
        buttonUnsubscribe: 'Unsubscribe from all',
        notifyInvalidEmail: (email) => { return `"${email}" is an invalid email address. Please check your entry and try again.`; },
        notifyGetError: (email) => { return `Failed to retrieve preferences for ${email}. Please check your entry and try again or <a href="/contact" class="alert-link">contact us</a>.`; },
        notifySetSuccess: `Your preferences have been updated.`,
        notifySetError: (email) => { return `Success! Please allow 48hrs for your preferences to be updated.`; },
        notifyUnsubscribe: `You have been unsubscribed from all marketing communications. We'll be sorry to see you go.`,
        notifySubscribe: `You have been subscribed to all marketing communications. Stay tuned for our exciting updates!`,
        notifyEmptyPreferences: (email) => { return ` We couldn't find any subscriptions for ${email}. Sign up to receive marketing communications by selecting your preferences below.`; }
    },
    fr: {
        title: 'Centre de préférences de communication | Esendex',
        headingMain: 'Mettre à jour mes préférences.',
        headingDetails: 'Mes informations',
        headingPreferences: 'Je veux en savoir plus sur',
        labelCopyright: '&copy; Commify UK Ltd 2019',
        labelEmail: 'Adresse email:',
        labelTypeNewproducts: 'Nouveautés produits / Nouvelles fonctionnalités',
        labelTypeNews: 'Nouveautés et développements',
        labelTypeSupport: 'Messages du Support Technique',
        labelTypeEvents: 'Informations évènements',
        labelTypeSurveys: 'Enquêtes / Demande d\'informations',
        labelTypePromotions: 'Promotions et offres spéciales',
        labelChannelEmail: 'Email',
        labelChannelSMS: 'SMS',
        labelLoading: 'Chargement...',
        buttonProceed: 'Envoi',
        buttonLoading: '<span>.</span><span>.</span><span>.</span>',
        buttonSave: 'Sauvegarder mes préférences',
        buttonSubscribe: 'Je m\'abonne à tout',
        buttonUnsubscribe: 'Je me désabonne de tout',
        notifyInvalidEmail: (email) => { return `"${email}" n'est pas une adresse valide. Merci de bien vouloir vérifier cette adresse et de recommencer.`; },
        notifyGetError: (email) => { return `Nous n'avons pas récupérer vos préférences pour l'adresse ${email}. Merci de bien vouloir vérifier cette adresse, recommencer ou de <a href="/contact" class="alert-link">Contactez nous</a>.`; },
        notifySetSuccess: `Vos préférences ont bien été mises à jour.`,
        notifySetError: (email) => { return `Nous vous remercions. Vos préférences de communication seront mises à jour dans les 48H.`; },
        notifyUnsubscribe: `Vous vous êtes désinscrit de toutes nos communications marketing. Nous sommes désolés de vous voir partir.`,
        notifySubscribe: `Vous avez souscrit à toutes nos communications marketing. Restez connecté(e) afin de recevoir nos dernières news!`,
        notifyEmptyPreferences: (email) => { return `L'adresse ${email} ne se trouve pas dans notre base de données. Veuillez sélectionner vos préférences ci-dessous afin de recevoir nos futures communications marketing.`; }
    },
    es: {
        title: 'Centro de preferencias de comunicación | Esendex',
        headingMain: 'Actualizar mis preferencias',
        headingDetails: 'Mis preferencias',
        headingPreferences: 'Quiero saber más sobre',
        labelCopyright: '&copy; Commify Iberia S.L 2019',
        labelEmail: 'Correo electrónico:',
        labelTypeNewproducts: 'Nuevos productos y actualizaciones',
        labelTypeNews: 'Noticias y estudios',
        labelTypeSupport: 'Mensajes de soporte técnico',
        labelTypeEvents: 'Información sobre eventos',
        labelTypeSurveys: 'Encuestas de opinión',
        labelTypePromotions: 'Ofertas y promociones',
        labelChannelEmail: 'Email',
        labelChannelSMS: 'SMS',
        labelLoading: 'Cargando...',
        buttonProceed: 'Enviar',
        buttonLoading: '<span>.</span><span>.</span><span>.</span>',
        buttonSave: 'Guardar preferencias',
        buttonSubscribe: 'Suscribirme a todas las comunicaciones',
        buttonUnsubscribe: 'Darme de baja de todas las comunicaciones',
        notifyInvalidEmail: (email) => { return `"${email}" no es una dirección de correo electrónico válida. Por favor, compruebala y prueba otra vez.`; },
        notifyGetError: (email) => { return `No hemos podido recuperar las preferencias para ${email}. Por favor, comprueba el email introducido y prueba otra vez o <a href="/contact" class="alert-link">Contáctenos</a>.`; },
        notifySetSuccess: `Tus preferencias han sido actualizadas.`,
        notifySetError: (email) => { return `Muchas gracias. Tus preferencias de comunicación se actualizarán en las próximas 48h.`; },
        notifyUnsubscribe: `Te has dado de baja de todas nuestras comunicaciones de marketing. ¡Sentimos verte partir!`,
        notifySubscribe: `Te has suscrito a todas nuestras comunicaciones de marketing. ¡Muchas Gracias!`,
        notifyEmptyPreferences: (email) => { return `El correo electrónico ${email} no está en nuestra base de datos. Regístrate para poder recibir nuestras comunicaciones de marketing y seleccionar tus preferencias.`; } 
    },
    de: {
        title: 'Verwalten Sie Ihre Kommunikationspräferenzen | Esendex',
        headingMain: 'Präferenzen aktualisieren',
        headingDetails: 'Meine Kontaktinformationen',
        headingPreferences: 'Ich möchte mehr wissen über',
        labelCopyright: '&copy; Commify UK Ltd 2019',
        labelEmail: 'E-Mail-Adresse: ',
        labelTypeNewproducts: 'Neue Produkte / Features',
        labelTypeNews: 'Nachrichten und Forschung',
        labelTypeSupport: 'Benachrichtigungen vom technichen Support',
        labelTypeEvents: 'Benachrichtigungen über Veranstaltungen',
        labelTypeSurveys: 'Umfragen / Rückmeldungen',
        labelTypePromotions: 'Rabatte / Sonderangebote',
        labelChannelEmail: 'E-Mail',
        labelChannelSMS: 'SMS',
        labelLoading: 'Lädt...',
        buttonProceed: 'Absenden',
        buttonLoading: '<span>.</span><span>.</span><span>.</span>',
        buttonSave: 'Präferenzen speichern',
        buttonSubscribe: 'Sich für alles anmelden',
        buttonUnsubscribe: 'Sich von allem abmelden',
        notifyInvalidEmail: (email) => { return `"${email}" ist keine gültige E-Mail-Adresse. Überprüfen Sie bitte Ihren Eintrag und versuchen Sie noch mal.`; },
        notifyGetError: (email) => { return `Wir konnten die Präferenzen für ${email} nicht abrufen. Überprüfen Sie bitte Ihren Eintrag und versuchen Sie es noch einmal, oder <a href="/contact" class="alert-link">kontaktieren Sie uns</a>.`; },
        notifySetSuccess: `Ihre Präferenzen wurden erfolgreich aktualisiert.`,
        notifySetError: (email) => { return `Sie haben Ihre Präferenzen erfolgreich geändert. Die Aktualisierung Ihrer Änderung kann bis zu 48h dauern, haben Sie bitte etwas Geduld.`; },
        notifyUnsubscribe: `Sie haben sich erfolgreich von allen Marketing Updates abgemeldet. Schade, dass Sie uns verlassen.`,
        notifySubscribe: `Erfolg Sie haben sich erfolgreich für alle Marketing Updates angemeldet. Bleiben Sie auf dem Laufenden mit unseren spannenden Updates!`,
        notifyEmptyPreferences: (email) => { return `Leider konnten wir keine Anmeldungen für ${email} finden. Bitte wählen Sie unten Ihre Präferenzen aus, um Marketingkommunikation zu erhalten.`; }
    }
};

function setCopy() {
    document.getElementById('heading-main').innerText = Strings[lang].headingMain;
    document.getElementById('loading').innerText = Strings[lang].labelLoading;
    document.getElementById('heading-details').innerText = Strings[lang].headingDetails;

    document.getElementById('label-email').innerText = Strings[lang].labelEmail;
    document.getElementById('submit-email').innerText = Strings[lang].buttonProceed;

    document.getElementById('text-email').innerHTML = Strings[lang].labelEmail + ' ' + document.getElementById('text-email').innerHTML;
    document.getElementById('heading-preferences').innerText = Strings[lang].headingPreferences;

    document.getElementById('label-channel-email').innerText = Strings[lang].labelChannelEmail;
    document.getElementById('label-channel-sms').innerText = Strings[lang].labelChannelSMS;

    document.getElementById('preferences-subscribe').innerText = Strings[lang].buttonSubscribe;
    document.getElementById('preferences-unsubscribe').innerText = Strings[lang].buttonUnsubscribe;
    document.getElementById('preferences-save').innerText = Strings[lang].buttonSave;

    document.getElementById('label-copyright').innerHTML = Strings[lang].labelCopyright;

    document.querySelector('title').innerText = Strings[lang].title;
}
